import { render } from "./bildirimCard.vue?vue&type=template&id=6eff4fe4"
import script from "./bildirimCard.vue?vue&type=script&lang=js"
export * from "./bildirimCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__